<template>
  <div>
    <b-container fluid class="table-controls position-relative">
      <div class="submit-group-btn position-absolute">
        <R-Button
          :secondary="true"
          v-if="hasDownload"
          class="d-inline-block"
          :hasShadow="true"
          :size="'small'"
          @onClick="download()"
          >Download CSV</R-Button
        >
        <R-Button
          v-if="hasSubmit"
          class="d-inline-block ml-3"
          :disabled="isSubmitDisabled || !isTableValid"
          :hasShadow="true"
          :size="'small'"
          @onClick="submit()"
          >Submit</R-Button
        >
        <R-Button
          v-if="hasCustomAction"
          class="d-inline-block ml-3"
          :hasShadow="true"
          :size="'small'"
          @onClick="customAction()"
          >{{ customActionTitle }}</R-Button
        >
      </div>
      <b-row v-if="hasEditActionButtons" class="py-1">
        <b-col>
          <R-Button
            :secondary="true"
            :isDisabled="isAddRowDisabled"
            class="d-inline-block"
            @onClick="addRowAction"
            :hasShadow="true"
            :size="'small'"
            >Add Row</R-Button
          >
          <R-Button
            :secondary="true"
            :isDisabled="!hasSelection"
            class="d-inline-block ml-3"
            @onClick="deleteRowAction"
            :hasShadow="true"
            :size="'small'"
            >Delete Row</R-Button
          >
          <R-Button
            :secondary="true"
            :isDisabled="!hasSelection"
            class="d-inline-block ml-3"
            @onClick="duplicateRowAction"
            :hasShadow="true"
            :size="'small'"
            >Duplicate Row</R-Button
          >

          <R-Button
            :secondary="true"
            class="d-inline-block ml-3"
            @onClick="undoAction"
            :hasShadow="true"
            :size="'small'"
            >Undo</R-Button
          >
          <R-Button
            :secondary="true"
            class="d-inline-block ml-3"
            @onClick="redoAction"
            :hasShadow="true"
            :size="'small'"
            >Redo</R-Button
          >
        </b-col>
      </b-row>
      <slot
        name="actionBar"
        :hasSelection="hasSelection"
        :getSelectedRows="getSelectedRows"
      />
      <!-- set column values-->
      <b-row v-if="hasSetActionButtons" class="py-2">
        <b-col cols="2">
          <R-Select
            :labelValue="'Column:'"
            :value="columnField"
            placeholder="Column"
            :size="'small'"
            :options="sColumnsOptions"
            ref="columnField"
            @onChange="
              $event
                ? (columnField = { label: $event.label, value: $event.value })
                : (columnField = null)
            "
          ></R-Select>
        </b-col>

        <b-col cols="2" v-if="!isColumnDataPredifined">
          <R-Label :theme="labelTheme" htmlFor="columnValue" value="Value:" />
          <R-Input
            :value="columnValue"
            @onChange="columnValue = $event.target.value"
            :size="'small'"
            type="text"
            placeholder="value to set"
          />
        </b-col>

        <b-col cols="2" v-else>
          <R-Select
            :labelValue="'Value:'"
            :value="sColumnValue"
            :size="'small'"
            :options="sPredefinedColumnValues"
            @onChange="
              $event ? onChangeColumnValue($event) : (sColumnValue = null)
            "
          ></R-Select>
        </b-col>

        <b-col class="pt-4 mt-1" cols="1">
          <R-Button
            :secondary="true"
            @onClick="setColumnValues()"
            class="d-inline-block"
            :hasShadow="true"
            :size="'small'"
            >Set</R-Button
          >
        </b-col>
      </b-row>
      <!-- filtering -->
      <b-row :class="recordsCssClass">
        <b-col v-if="hasFilterActionButtons" class="mt-3" cols="8" sm="10">
          <a
            class="adv-btn collapsed"
            :href="'#collapse-filter'"
            @click.prevent
            v-b-toggle.collapse-filter
          >
            <h6 class="d-inline mr-4 ml-2">
              Filter
              <ArrowDownIcon
                class="d-inline"
                :theme="iconTheme"
              ></ArrowDownIcon>
            </h6>
          </a>
          <span class="filter-control pt-4 mt-1">
            <R-Checkbox
              class="d-inline-block align-middle checkbox-wrapper"
              :isChecked="cbFailedFilter.state"
              :label="cbFailedFilter.message"
              @onChange="
                cbFailedFilter.state = !cbFailedFilter.state;
                updateFilter();
              "
            />
            <R-Checkbox
              class="d-inline-block ml-3 align-middle checkbox-wrapper"
              v-if="isEditable"
              :isChecked="cbEditedFilter.state"
              :label="cbEditedFilter.message"
              @onChange="
                cbEditedFilter.state = !cbEditedFilter.state;
                updateFilter();
              "
            />
            <R-Button
              class="d-inline-block ml-3"
              @onClick="clearFilter"
              :hasShadow="true"
              :size="'small'"
              >Clear Filter</R-Button
            >
          </span>
          <b-collapse id="collapse-filter" class="mt-2">
            <b-row v-for="(filter, index) in filtersList" :key="index">
              <b-col cols="3">
                <span
                  v-if="index > 0"
                  @click="deleteFilter(index)"
                  class="float-left minus-plus-icon cursor-pointer"
                >
                  <MinusCircleIcon
                    class="d-inline"
                    :theme="iconTheme"
                  ></MinusCircleIcon>
                </span>
                <R-Select
                  :labelValue="'Field:'"
                  class="ml-4"
                  placeholder="Column"
                  :size="'small'"
                  :value="filter.filterField"
                  :options="sFilterFieldOptions"
                  ref="filterField"
                  @onChange="
                    $event
                      ? (filter.filterField = {
                          label: $event.label,
                          value: $event.value,
                        })
                      : (filter.filterField = null);
                    isColumnDataPredifinedFilter(filter);
                    updateFilter($event);
                  "
                ></R-Select>
              </b-col>
              <b-col cols="3">
                <R-Select
                  :labelValue="'Type:'"
                  placeholder="Filter"
                  :size="'small'"
                  :value="filter.filterType"
                  :options="sFilterTypeOptions"
                  ref="filterType"
                  @onChange="
                    $event
                      ? (filter.filterType = {
                          label: $event.label,
                          value: $event.value,
                        })
                      : (filter.filterType = null);
                    updateFilter();
                  "
                ></R-Select>
              </b-col>

              <b-col cols="3">
                <span
                  @click="addFilter(index)"
                  class="float-right minus-plus-icon cursor-pointer"
                >
                  <PlusCircleIcon
                    class="d-inline"
                    :theme="iconTheme"
                  ></PlusCircleIcon>
                </span>

                <div class="mr-4" v-if="!filter.isColumnDataPredifined">
                  <R-Label
                    :theme="labelTheme"
                    htmlFor="filterValue"
                    value="Value:"
                  />
                  <b-form-input
                    :class="['oxy-input', { 'border-danger': false }]"
                    @input="updateFilter"
                    v-model="filter.filterValue"
                  ></b-form-input>
                </div>
                <div class="mr-4" v-else>
                  <R-Select
                    :labelValue="'Value:'"
                    :size="'small'"
                    :value="filter.filterValue"
                    :options="filter.predefinedColumnValues"
                    @onChange="
                      $event
                        ? (filter.filterValue = {
                            label: $event.label,
                            value: $event.value,
                          })
                        : (filter.filterValue = null);
                      updateFilter();
                    "
                  ></R-Select>
                </div>
              </b-col>
            </b-row>
          </b-collapse>
        </b-col>
        <b-col
          v-if="!hideActiveRowCount"
          cols="4"
          sm="2"
          class="text-right mt-3"
        >
          <span class="">{{ activeRows }}/{{ dataCount }} records</span>
        </b-col>
      </b-row>
    </b-container>

    <!-- table -->
    <div class="position-relative">
      <div ref="tabulator"></div>
      <div
        v-if="loaderActive"
        class="align-items-center d-flex justify-content-center position-absolute tabulator-loader-overlay"
      >
        <span class="spinner-lg spinner-border text-primary">
          <span class="sr-only">Loading</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Tabulator from "tabulator-tables"; //import Tabulator library
import debounce from "lodash/debounce";

var jsondiffpatch = require("jsondiffpatch");
import Papa from "papaparse";

export default {
  name: "table-view",
  components: {},
  props: {
    /**
     * Value / Initial value of data (original data)
     */
    value: {
      default: function () {
        return [];
      },
    },
    /**
     * Options array of tabulator options
     */
    options: {
      default: function () {
        return {};
      },
    },
    /**
     *  Define validation data
     */
    validationData: {
      default: function () {
        return {};
      },
    },
    /**
     * Tell if table cells are editable
     */
    isEditable: {
      type: Boolean,
      default: true,
    },
    /**
     * Tell if loader is shown
     */
    showLoader: {
      type: Boolean,
      default: false,
    },
    /**
     * Define array of editable columns
     */
    editableColumns: {
      default: function () {
        return [];
      },
    },
    /**
     * Define callback function for columns editable property
     */
    editableCallback: {
      default: function () {
        return null;
      },
    },
    /**
     * Define cell formatter
     */
    formatterCell: {
      default: function () {
        return null;
      },
    },
    /**
     * Define cell formatter
     */
    mutator: {
      default: function () {
        return null;
      },
    },
    /**
     * Define array of hidden columns
     */
    hiddenColumns: {
      default: function () {
        return [];
      },
    },
    /**
     * Define array of visible columns. If defined all other columns are hidden
     */
    visibleColumns: {
      default: function () {
        return [];
      },
    },
    /**
     * Optional. Accepts an object of the form
     * { [key]: {accessorDownload:..., accessorDownloadParams:...} }.
     *
     * See https://tabulator.info/docs/4.8/download#advanced-accessors
     * for usage information and examples.
     */
    downloadAccessors: {
      default: function () {
        return null;
      },
    },
    /**
     * Define array of grouped columns. Columns that have same header
     */
    columnGroups: {
      default: function () {
        return [];
      },
    },
    /**
     * Define array of column titles
     */
    columnTitles: {
      default: function () {
        return [];
      },
    },

    /**
     * Tell if table header has edit action buttons
     */
    hasEditActionButtons: {
      type: Boolean,
      default: true,
    },
    /**
     * Tell if table header has set action buttons
     */
    hasSetActionButtons: {
      type: Boolean,
      default: true,
    },
    /**
     * Tell whether to hide the number of selected rows
     */
    hideActiveRowCount: {
      type: Boolean,
      default: false,
    },
    /**
     * Function handling custom row formatting logic.
     */
    _rowFormatter: {
      type: Function,
      default: null,
    },
    /**
     * Tell if table header has filter action buttons
     */
    hasFilterActionButtons: {
      type: Boolean,
      default: true,
    },
    /**
     * Tell if submit button is disabled
     */
    isAddRowDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Tell if submit button is disabled
     */
    isSubmitDisabled: {
      type: Boolean,
      default: false,
    },
    /**
     * Tell if table has submit action
     */
    hasSubmit: {
      type: Boolean,
      default: true,
    },
    /**
     * Tell if table to submit only changed rows
     */
    submitEditedRows: {
      type: Boolean,
      default: false,
    },
    /**
     * Tell if table has download action
     */
    hasDownload: {
      type: Boolean,
      default: true,
    },
    /**
     * Tell if table has custom action
     */
    hasCustomAction: {
      type: Boolean,
      default: false,
    },
    /**
     * Define custom action button text
     */
    customActionTitle: {
      type: String,
      default: "Send",
    },
    /**
     * Tell if table has custom download. return data for proccessing instead of
     */
    hasCustomDownload: {
      type: Boolean,
      default: false,
    },
    /**
     * Set download file name
     */
    downloadFileTitle: {
      type: String,
      default: "Data",
    },
    /**
     * Define ajax params (url, prams)
     */
    ajaxParams: {
      default: function () {
        return {};
      },
    },
    /**
     * Define css class for records row. used when there is only records row with one of the submit buttons
     */
    recordsCssClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      labelTheme: { fontWeight: 600 },
      iconTheme: { color: "#0376DA", size: "18px" },
      showloader: false, //local variable. used to show loader frim table component(this). ex. setting data to column
      //filtering variables______________________________________________________
      filtersList: [
        {
          filterField: null, //+filter column
          filterValue: null, //+filter value
          filterType: null, // filter  type
          isColumnDataPredifined: false,
          predefinedColumnValues: [],
        },
      ],
      cbFailedFilter: {
        //+ failed cells checkbox
        state: false,
        message: "Show invalid rows",
      },

      sFilterTypeOptions: [
        {
          value: "like",
          label: "contains",
        },
        {
          value: "=",
          label: "equals",
        },
        {
          value: "!=",
          label: "not equal",
        },
        {
          value: ">=",
          label: ">=",
        },
        {
          value: "<=",
          label: "<=",
        },
      ],
      cbEditedFilter: {
        //+ edited cells checkbox
        state: false,
        message: "Show edited rows",
      },
      //Action table controls
      cbSelectAll: {
        //+ used to select all rows and keep track of all individial select buttons
        state: false,
        message: "Select All",
      },
      columnField: null, // selected column to change all values in column
      columnValue: "", //value to set for all cells in selected column
      sColumnValue: null,
      //tabulator variables_________________________________________________________
      delta: null, // difference between original data and data updated trough tabulator
      diffpatcher: null, //json diff patcher object
      tabulator: null, //variable to hold your table
      tableData: [], //data for table to display
      columns: [], //tabluator columns
      // validationData: [], // validation data generated from csv validation file
      isSubmit: false, //flag to indicate to tabulator that action is submit instead of download
      isCustomAction: false, //flag to indicate to tabulator that action is submit instead of download
      isAjaxRequest: false, //flag to indicate that tabulator data is loded using ajax request
      isDeleting: false, //flag to indicate when tabulator is deleting data
      // tabulator options _________      _____________________________________________________
      tabulatorOptions: {
        data: [], //link data to table
        reactiveData: true, //enable data reactivity
        clipboard: true, //enable copy/pasting
        placeholder: "No Data Available",
        history: true, // used for redo and undo actions
        addRowPos: "top", // position of added row. (top or bottom)
        layout: "fitDataFill", // stretch table accros all available space
        // layout:"fitColumns", // stretch table accros all available space
        // virtualDomBuffer:600,
        validationMode: "highlight",
        height: "150px", //? set height of table (in CSS or here), this enables the Virtual DOM and improves render speed dramatically (can be any valid css height value)
        // minHeight: '150px',
        maxHeight: "100vh",
        columns: [], //Define Table Columns

        // downloadRowRange:"selected",
        // selectable:true,
        /************************ pagination ************************/
        renderStarted: function () {
          console.log("renderStarted");
          if (this.getData().length == 0) {
            this.setHeight("150px");
          } else {
            //set height to auto so tabulator calculates its own height
            this.setHeight("auto");
            console.log("heights");
            //if calculated tabulator height is bigger/equal to client height => set height to max client height so tabulator can calculate its height.
            //tabulator calculates its height=> tabulator-tableHolder div calcs its heights  height: calc(100% - 108px); where 100% is parent tabulator div height
            // tabulator auto height for small number of rows. if number of rows is bigger than space allowed and scrolling needs to be implemented than we have to set explicit height so tabulator can draw footer correctly
            let bodyRect = document.body.getBoundingClientRect();
            let tabulatorRect = this.element.getBoundingClientRect();
            console.log("tabulatorRect.height");
            console.log(tabulatorRect.height);
            // for screens with small height set height to 100vh
            let availableHeight = bodyRect.bottom - 25 - tabulatorRect.top;
            console.log("availableHeight");
            console.log(availableHeight);
            //if available height < 300 and tabulator height < 300 than leave auto, if tabulator height >= available
            if (availableHeight <= 300) this.setHeight("100vh");
            // else  if tabulator height is bigger than available space
            else if (tabulatorRect.height >= availableHeight)
              this.setHeight(availableHeight);
          }
        },
        dataLoading: (data) => {
          console.log("dataLoading");
          //data - all data loaded into the table
          if (this.isAjaxRequest) {
            console.log("dataLoading isAjaxRequest");
            if (data.length > 0) {
              this.columns = this.createTableColumns(data);
              this.tabulator.setColumns(this.columns);
            }

            this.isAjaxRequest = false;
          }
        },
        dataLoaded: (data) => {
          console.log("DATA LOADED");
          //data - all data loaded into the table
          this.$emit("dataLoaded");
        },
        ajaxRequesting: (url, params) => {
          //url - the URL of the request
          //params - the parameters passed with the request
          console.log("ajaxRequesting");
          this.isAjaxRequest = true;
        },
        /************************ ROW SELECTION ************************/
        // selectableCheck:(row)=>{
        //     //row - row component
        //     console.log('selectableRowCheck')
        //     // console.log(this.tabulator.rowManager.displayRows)
        //     console.log(row.getTable().rowManager.displayRows)
        //     let record = this._.find(row.getTable().rowManager.displayRows[1], r => { return r.getData().id == row.getData().id })
        //     return  record ? true : false
        //     // return  this.tabulator.rowManager.displayRows[1]
        //     // return true; //allow selection of rows where the age is greater than 18
        // },
        rowClick: (e, row) => {
          //e - the click event object
          //row - row component
          this.$emit("rowClick", row.getData());
        },
        cellClick: (e, cell) => {
          //e - the click event object
          //cell - cell component
          this.$emit("cellClick", e, cell);
        },
        // dataChanged:(data)=>{
        //data - the updated table data
        // console.log('dataChanged')
        // console.log(JSON.stringify(data))
        // this.delta = this.diffpatcher.diff(this.value, data);
        // },
        // rowUpdated:function(row){
        // //row - row component
        // console.log('rowUpdated')
        //     console.log(JSON.stringify(row.getData()))
        // },
        rowFormatter: (row) => {
          if (!this.isDeleting) {
            // console.log('rowFormatter '+row.getIndex())
            // console.log( JSON.stringify(this.delta))
            //row - row component
            row.validate();

            // //check if every cell in row is visible and revert value back to original if cell is not editable but is updated trough set value to entire column functionality.
            this._.forEach(row.getCells(), (cell, key) => {
              if (cell.getColumn().isVisible()) {
                let editable = cell.getColumn().getDefinition().editable;

                if (typeof editable === "function" && !editable(cell)) {
                  //cell is not editable
                  if (
                    this.delta &&
                    this.delta[cell.getRow().getIndex()] &&
                    this.delta[cell.getRow().getIndex()][cell.getField()]
                  ) {
                    cell.setValue(
                      this.delta[row.getIndex()][cell.getField()][0]
                    );
                    if (
                      cell.getElement() &&
                      cell
                        .getElement()
                        .classList.contains("tabulator-cell__edited")
                    ) {
                      cell
                        .getElement()
                        .classList.remove("tabulator-cell__edited");
                    }
                  }
                }
              }
            });
          }

          // Allow additional customization via prop function.
          if (this._rowFormatter) {
            this._rowFormatter(row);
          }
        },
        rowSelectionChanged: (data, rows) => {
          this.$emit("rowSelectionChanged", { data, rows });
        },
        /************************ CELL EDITING ************************/
        cellEdited: (cell) => {
          //emit cell edited event
          this.$emit("cellEdited", cell);
        },
        /************************ FILTERING ************************/

        /************************ DOWNLOAD AND SUBMIT ************************/
        downloadReady: (fileContents, blob) => {
          //fileContents - the unencoded contents of the file
          //blob - the blob object for the download

          if (this.isSubmit) {
            if (this.hasSelection) {
              console.log("submit SELECTED");
              console.log(this.tabulator.getSelectedData());
              // this.$emit('submit', this.tabulator.getSelectedData())
              this.emitData("submit", this.tabulator.getSelectedData());
            } else if (!this.submitEditedRows) {
              console.log("submit ALL");
              // this.$emit('submit', this.tabulator.getData())
              this.emitData("submit", this.tabulator.getData());
            } else {
              console.log("submit EDITED");
              this.delta = this.diffpatcher.diff(
                this.value,
                this.tabulator.getData()
              );

              let keys = this._.keys(this.delta);
              let editedRows = this._.filter(
                this.tabulator.getData(),
                (v, k) => {
                  return this._.includes(keys, k.toString());
                }
              );
              console.log("editedRows");
              console.log(editedRows);
              // this.$emit('submit', editedRows)
              this.emitData("submit", editedRows);
            }
            return false; //must return a blob to proceed with the download, return false to abort download
          } else if (this.isCustomAction) {
            console.log("submit CUSTOM");
            // this.$emit('custom', this.tabulator.getData())
            this.emitData("custom", this.tabulator.getData());
            return false; //must return a blob to proceed with the download, return false to abort download
          } else {
            if (this.hasSelection) {
              let downloadSelectedData = this._.map(
                this.tabulator.getSelectedData(),
                (value, key) => {
                  return this._.omit(value, ["id"]);
                }
              );
              let csv = Papa.unparse(downloadSelectedData);
              let selectedDataBlob = new Blob([csv], {
                type: "application/csv",
              });
              this.$emit("download", downloadSelectedData);
              return selectedDataBlob;
            } else {
              console.log("download");
              this.$emit("download", fileContents);
              return blob;
            }
          }
        },
      },
    };
  },
  watch: {
    //update table if data changes
    value: {
      immediate: true,
      handler: function (newVal, oldVal) {
        console.log("input value watcher");
        this.delta = null;
        //format data for tabulator. add id field adn replace . ' ' with _
        let data = this._.map(newVal, (value, key) => {
          value["id"] = key;
          return this._.mapKeys(value, function (v, k) {
            return k.replace(/[\. ,:-]+/g, "_").trim();
          });
        });
        // create copy of the initial data and assign it to tabulator. This way original data is saved in value
        this.tableData = JSON.parse(JSON.stringify(data));
        //create columns if data exists
        if (data.length > 0) {
          this.columns = this.createTableColumns(this.tableData);
        }
        if (this.tabulator) {
          console.log("input value watcher: replacing data from IF  tabulator");
          this.tabulator.setColumns(this.columns);
          this.tabulator.replaceData(this.tableData);
          this.tabulator.validate();
        }
      },
      deep: true,
    },
    validationData: {
      handler: function (newVal, oldVal) {
        console.log("validationData watcher");
        console.log(newVal);
        if (this.value.length > 0 && this.tabulator) {
          this.columns = this.createTableColumns(this.tabulator.getData());
          this.tabulator.setColumns(this.columns);
          this.tabulator.validate();
        }
      },
      deep: true,
    },
    options: {
      handler: function (newVal, oldVal) {
        console.log("options watcher");
        console.log(newVal);
        //create table data
        this.tabulatorOptions = this._.merge(this.tabulatorOptions, newVal);
        this.tabulator = new Tabulator(
          this.$refs.tabulator,
          this.tabulatorOptions
        );
      },
      deep: true,
    },
    ajaxParams: {
      handler: function (newVal, oldVal) {
        console.log("ajaxParams watcher");
        console.log(newVal);
        //set data from ajax
        if (this.tabulator && newVal.url)
          this.tabulator.setData(
            newVal.url,
            newVal.params ? newVal.params : {}
          );
      },
      deep: true,
    },
  },
  computed: {
    isTableValid() {
      //if no taulator => false
      // OR tabulator has invalid cells
      //OR if has selection and selected rows have invalid cells
      if (this.tabulator) {
        let isValid = true;
        if (this.hasSelection) {
          for (let row of this.tabulator.getSelectedRows()) {
            if (row.validate().length > 0) {
              isValid = false;
              break;
            }
          }
        } else if (this.tabulator.getInvalidCells().length > 0) {
          isValid = false;
        }
        return isValid;
      } else return false;
    },
    hasSelection: function () {
      return this.tabulator
        ? !this._.isEmpty(this.tabulator.getSelectedRows())
        : false;
    },
    dataCount: function () {
      return this.tabulator ? this.tabulator.getDataCount() : 0;
    },
    activeRows: function () {
      return this.tabulator ? this.tabulator.rowManager.activeRows.length : 0;
    },
    loaderActive: function () {
      return this.showLoader || this.showloader;
    },

    /***  SETTING VALUES ***/
    sColumnsOptions() {
      let options = [];
      if (this.tabulator) {
        this.tabulator.getColumns().forEach((col, key) => {
          if (
            !!col.getDefinition().editor &&
            (this._.includes(this.editableColumns, col.getField()) ||
              this.isEditable)
          ) {
            options.push({
              value: col.getField(),
              label:
                (col.getParentColumn()
                  ? col.getParentColumn().getDefinition().title + " "
                  : "") + col.getDefinition().title.replace(/_/g, " "),
            });
          }
        });
      }

      return options;
    },
    // assignig values to entire column
    isColumnDataPredifined: function () {
      if (
        this.tabulator &&
        this.columnField &&
        this.tabulator.getColumn(this.columnField.value)
      ) {
        console.log("isColumnDataPredifined");
        this.columnValue = "";
        this.sColumnValue = null;
        return this.tabulator.getColumn(this.columnField.value).getDefinition()
          .editorParams.values.length > 0
          ? true
          : false;
      } else {
        return false;
      }
    },
    sPredefinedColumnValues: function () {
      if (this.tabulator && this.tabulator.getColumn(this.columnField.value)) {
        let options = [];
        this.tabulator
          .getColumn(this.columnField.value)
          .getDefinition()
          .editorParams.values.forEach((col, key) => {
            options.push({
              value: col,
              label: col,
            });
          });
        return options;
      } else {
        return "";
      }
    },
    /*** FILTERING ***/
    sFilterFieldOptions() {
      let options = [];
      if (this.tabulator) {
        this.tabulator.getColumns().forEach((col, key) => {
          if (col.getDefinition().visible && col.getDefinition().title) {
            options.push({
              value: col.getField(),
              label:
                (col.getParentColumn()
                  ? col.getParentColumn().getDefinition().title + " "
                  : "") + col.getDefinition().title.replace(/_/g, " "),
            });
          }
        });
      }
      return options;
    },
  },
  methods: {
    onChangeColumnValue: function (event) {
      this.columnValue = event.value;
      this.sColumnValue = { label: event.label, value: event.value };
    },
    //************* DATA METHODS **************************//
    //*******************************************************//

    createTableColumns(inputData) {
      console.log("createTableColumns: ");

      let data = [];
      let groupedColumns = [];
      let clonedColumnGroups = [];
      let groupedColumnFlag = false;

      if (inputData.length > 0) {
        //cloning columnGroups to preserv original array.
        if (this.columnGroups.length > 0) {
          clonedColumnGroups = JSON.parse(JSON.stringify(this.columnGroups));
        }

        //add select row column
        data.push({
          title: "#",
          editable: false,
          formatter: "rownum",
          width: 50,
          download: false,
        });
        data.push({
          formatter: "rowSelection",
          editable: false,
          download: false,
          titleFormatter: "rowSelection",
          titleFormatterParams: { rowRange: "active" },
          hozAlign: "center",
          headerSort: false,
          width: 50,
        });

        // create Columns for table from csv file
        this._.forEach(inputData[0], (value, key) => {
          let editor = "input";
          let editorParams = { values: [] };
          // set column editor option
          if (this.validationData && this.validationData[key]) {
            this.validationData[key].map(function (val, k) {
              if (val.type == "in") {
                editorParams.values = val.parameters.split("|");
                if (editorParams.values.length < 5) {
                  editor = "select";
                } else {
                  editor = "autocomplete";
                  editorParams.showListOnEmpty = true;
                  editorParams.allowEmpty = true;
                }
              }
            });
          }

          //column visibility
          let visible = true;
          if (
            key == "id" ||
            this._.includes(this.hiddenColumns, key) ||
            (this.visibleColumns.length > 0 &&
              !this._.includes(this.visibleColumns, key))
          ) {
            visible = false;
          }

          // need to reformat titles for BPS back to their original state: ex. User.LastName
          let col = {
            title: this.columnTitles[key] ? this.columnTitles[key] : key,
            titleFormatter: function (cell) {
              return cell.getValue().replace(/_/g, " ");
            },
            field: key,
            editor,
            editorParams,
            visible,
            download: visible,
            editable: this.editableCallback
              ? this.editableCallback
              : (cell) => {
                  //cell - the cell component for the editable cell
                  if (
                    this._.includes(
                      this.editableColumns,
                      cell.getColumn().getField()
                    )
                  ) {
                    return true;
                  } else {
                    return this.isEditable;
                  }
                },
            hozAlign: "left",
            cssClass: "text-left",
            validator: this.validationData[key] ? this.validationData[key] : "",
            mutator: (val, rowData, type, mutatorParams, cell) => {
              //val - original value of the cell
              //rowData - the data for the row
              //type - the type of mutation occurring  (data|edit)
              //mutatorParams - the mutatorParams object from the column definition
              //cell - when the "type" argument is "edit", this contains the cell component for the edited cell, otherwise it is undefined

              return this.mutator
                ? this.mutator(val, rowData, type, mutatorParams, cell, key)
                : val; //return the new value for the cell data.
            },
            formatter: (cell, formatterParams, onRendered) => {
              //  console.log('cell formatter')

              //changing background color to edited cells
              //1. if cell is edited
              //2. if cells old value isnt equal to new value. this occures when data of visible cell is updated (ex. via row.update({property:newVal}))
              //3. if data is updated and cell is not visible. when first drawn check if cell is present in delta  and change background color. delta is data differece
              if (
                (cell.isEdited && cell.isEdited()) ||
                (cell.getOldValue &&
                  cell.getOldValue() != null &&
                  (cell.getOldValue && cell.getOldValue()) !=
                    (cell.getValue && cell.getValue())) ||
                (this.delta &&
                  this.delta[cell.getRow().getIndex()] &&
                  this.delta[cell.getRow().getIndex()][cell.getField()])
              ) {
                cell.getElement().classList.add("tabulator-cell__edited");
              } else {
                if (
                  cell.getElement().classList.contains("tabulator-cell__edited")
                ) {
                  cell.getElement().classList.remove("tabulator-cell__edited");
                }
              }

              return this.formatterCell
                ? this.formatterCell(cell, formatterParams, onRendered)
                : cell.getValue();
            },
          };

          if (this.downloadAccessors && this.downloadAccessors[key]) {
            const { accessorDownload, accessorDownloadParams } =
              this.downloadAccessors[key];
            col = { ...col, accessorDownload, accessorDownloadParams };
          }

          //grouping columns
          if (this.columnGroups.length > 0) {
            groupedColumnFlag = false;

            groupedColumns = clonedColumnGroups.map((val) => {
              val.columns = val.columns.map((field) => {
                if (field == key) {
                  groupedColumnFlag = true;
                  return col;
                } else {
                  return field;
                }
              });
              return val;
            });
          }

          if (!groupedColumnFlag) {
            data.push(col);
          }
        });
      }

      if (groupedColumns.length > 0) {
        data = this._.concat(data, groupedColumns);
      }

      console.log(data);
      return data;
    },

    /************************ DOWNLOAD AND SUBMIT ************************/
    //*******************************************************//
    submit() {
      console.log("submit");
      this.isSubmit = true;
      this.tabulator.download(
        "json",
        "data.json",
        {},
        this.hasSelection ? "selected" : ""
      );
    },
    customAction() {
      console.log("custom action");
      this.isCustomAction = true;
      this.tabulator.download("json", "data.json");
    },
    download() {
      console.log("download");
      this.isSubmit = false;
      this.isCustomAction = false;
      this.tabulator.download("csv", this.downloadFileTitle + ".csv");
    },
    emitData(event, data) {
      console.log("emmitData");
      this.$emit(
        event,
        this._.map(data, (value, key) => {
          return this._.omit(value, ["id"]);
        })
      );
    },
    // ************* TABLE FILTERING **************************//
    //***********************************************************//
    deleteFilter(index) {
      console.log("delete filter");
      console.log(index);
      this.filtersList.splice(index, 1);
      this.updateFilter();
    },
    addFilter(index) {
      console.log("add filter");
      console.log(index);
      this.filtersList.splice(index + 1, 0, {
        filterField: null, //+filter column
        filterValue: null, //+filter value
        filterType: null, // filter  type
        isColumnDataPredifined: false,
        predefinedColumnValues: [],
      });
    },
    isColumnDataPredifinedFilter: function (filter) {
      if (
        this.tabulator &&
        filter.filterField &&
        this.tabulator.getColumn(filter.filterField.value)
      ) {
        console.log("isColumnDataPredifinedFilter");
        //
        if (
          this.tabulator.getColumn(filter.filterField.value).getDefinition()
            .editorParams.values.length > 0
        ) {
          filter.predefinedColumnValues = this._.map(
            this.tabulator.getColumn(filter.filterField.value).getDefinition()
              .editorParams.values,
            (val) => ({ value: val, label: val })
          );
          filter.isColumnDataPredifined = true;
        } else {
          filter.predefinedColumnValues = [];
          filter.isColumnDataPredifined = false;
          if (filter.filterValue && filter.filterValue.value)
            filter.filterValue = "";
        }
      }
    },

    updateFilter: debounce(function (e) {
      console.log("updateFilter");
      this.tabulator.clearFilter();

      if (this.cbFailedFilter.state) {
        // add failed validation filter
        this.tabulator.setFilter(this.failedValidationFilter);
      }
      //edited cells filter
      if (this.cbEditedFilter.state) {
        if (this.tabulator.getFilters().length == 0)
          this.tabulator.setFilter(this.editedCellsFilter);
        else this.tabulator.addFilter(this.editedCellsFilter);
      }
      //ALL OTHER FILTERS
      this.filtersList.forEach((filter, key) => {
        if (filter.filterField && filter.filterType) {
          let value = "";
          if (filter.filterValue && filter.filterValue.value)
            value = filter.filterValue.value;
          else if (filter.filterValue) value = filter.filterValue;

          if (this.tabulator.getFilters().length == 0) {
            this.tabulator.setFilter(
              filter.filterField.value,
              filter.filterType.value,
              value
            );
          } else
            this.tabulator.addFilter(
              filter.filterField.value,
              filter.filterType.value,
              value
            );
        }
      });
    }, 500),

    clearFilter: function () {
      //clearing all filters
      console.log("clearFilter");

      this.filtersList = [
        {
          filterField: null, //+filter column
          filterValue: null, //+filter value
          filterType: null, // filter  type
          isColumnDataPredifined: false,
          predefinedColumnValues: [],
        },
      ];
      this.cbFailedFilter.state = false;
      this.cbEditedFilter.state = false;

      this.tabulator.clearFilter();
    },
    failedValidationFilter: function (row) {
      //row element gets pasted by tabulator
      //validate method returns array of cell that failed validation or true if row passed validation
      return this.tabulator.getRow(row.id).validate().length > 0 ? true : false;
    },
    editedCellsFilter: function (row) {
      //row element gets pasted by tabulator
      let display = false;
      for (let cell of this.tabulator.getEditedCells()) {
        if (this._.isEqual(cell.getRow().getData(), row)) {
          display = true;
          break;
        }
      }
      return display;
    },
    //************* ROW METHODS ***********************//
    //***********************************************************//
    // rowNumberFormatter: function(cell){
    //     let page = cell.getTable().getPage();
    //     let pageSize = cell.getTable().getPageSize();
    //     let rowIndex = cell.getRow().getPosition(true);

    //     return ( (rowIndex+1) + ((page && pageSize) ? (page - 1) * pageSize : 0))+'.';
    // },
    //************* ACTION METHODS **************************//
    //*******************************************************//
    addRowAction: function () {
      // function used to submit data
      this.tabulator.addRow({ id: ++this.tabulator.getData().length });
      //redraw table to reset row numbers
      this.tabulator.redraw(true);
    },
    deleteRowAction: async function () {
      this.isDeleting = true;
      this.showloader = true;

      setTimeout(() => {
        this.tabulator
          .deleteRow(this.tabulator.getSelectedRows())
          .then(() => {
            //run code after row has been deleted
            console.log("DONE Deleting");
            this.isDeleting = false;
            this.showloader = false;
          })
          .catch((error) => {
            this.isDeleting = false;
            this.showloader = false;
          });
      }, 0);
    },
    duplicateRowAction() {
      this.tabulator.getSelectedRows().forEach((row) => {
        this.tabulator.addRow({
          id: ++this.tabulator.getData().length,
          ...row.getData(),
        });
      });
    },
    undoAction: function () {
      this.tabulator.undo();
    },
    redoAction: function () {
      this.tabulator.redo();
    },
    copyToClipboardAction: function () {
      this.tabulator.copyToClipboard("selected"); //copy the currently selected rows to the clipboard
    },
    getSelectedRows() {
      return this.tabulator.getSelectedRows();
    },
    setColumnValues: function () {
      //set values to entire column

      if (this.columnField && this.columnValue) {
        this.showloader = true;
        setTimeout(() => {
          let rowsForUpdate = [];
          let rowsForDiff = this.tabulator.getData();
          if (this.hasSelection) {
            this._.forEach(this.tabulator.getSelectedRows(), (row, key) => {
              if (row.getData()[this.columnField.value] != this.columnValue) {
                let obj = JSON.parse(JSON.stringify(row.getData()));
                obj[this.columnField.value] = this.columnValue;

                rowsForUpdate.push(obj);
                // rowsForUpdate.push({id: row.getData().id, [this.columnField.value]: this.columnValue})
                let record = this._.find(rowsForDiff, (r, k) => {
                  return r.id == row.getData().id;
                });
                if (record) record[this.columnField.value] = this.columnValue;
              }
            });
          } else {
            this._.forEach(
              this.tabulator.rowManager.getDisplayRows(),
              (row, key) => {
                if (row.getData()[this.columnField.value] != this.columnValue) {
                  let obj = JSON.parse(JSON.stringify(row.getData()));
                  obj[this.columnField.value] = this.columnValue;

                  rowsForUpdate.push(obj);
                  // rowsForUpdate.push({id: row.getData().id, [this.columnField.value]: this.columnValue})
                  // create array that is used to calculate delata before updating data. so delta can be used in row formatter
                  let record = this._.find(rowsForDiff, (r, k) => {
                    return r.id == row.getData().id;
                  });
                  if (record) record[this.columnField.value] = this.columnValue;
                }
              }
            );
          }
          this.delta = this.diffpatcher.diff(this.value, rowsForDiff);

          if (rowsForUpdate.length == 0) this.showloader = false;

          this.tabulator
            .updateData(rowsForUpdate)
            .then(() => {
              console.log("setColumnValues than");
              console.log(JSON.stringify(this.tabulator.getData()));
              this.delta = this.diffpatcher.diff(
                this.value,
                this.tabulator.getData()
              );
              this.tabulator.validate();
              rowsForDiff = [];
              //run code after data has been updated
              this.showloader = false;
            })
            .catch(function (error) {
              console.log("setColumnValues error");
              this.delta = this.diffpatcher.diff(
                this.value,
                this.tabulator.getData()
              );
              //handle error updating data
              rowsForDiff = [];
              this.showloader = false;
            });
        }, 0);
      }
    },
    //action used to redraw table. ex when switching tabs in AA tool
    redrawTableAction() {
      if (this.tabulator) this.tabulator.redraw(true);
    },
  },
  created() {
    // create a configured instance, match objects by name
    this.diffpatcher = jsondiffpatch.create({
      objectHash: function (obj) {
        return obj.id;
      },
    });
  },

  mounted() {
    console.log("mounted TABLEVIEW");
    // initial setup
    this.tabulatorOptions.columns = this.columns;
    this.tabulatorOptions = this._.merge(this.tabulatorOptions, this.options);

    //instantiate Tabulator when element is mounted
    this.tabulator = new Tabulator(this.$refs.tabulator, this.tabulatorOptions);
    this.tabulator.replaceData(this.tableData);
  },
};
</script>
